import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Landlords/PaymentsTables";
import SummaryCard from "../../Components/Landlords/SummaryCard";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { LargeSummarySkeletonLoading } from "../../Components/SkeletonLoading";
import DateRange from "../../Components/DateRange";
import SearchFilterBox from "../../Components/SearchFilterBox";
import ViewTransDetails from "../../Components/Landlords/ViewTransDetails";
import SideModal from "../../Components/SideModal";

const Payments = () => {
  const searchOptions = [
    { label: "Name", value: 3 },
    { label: "Mobile", value: 1 },
    { label: "Property", value: 5 },
    // { label: "Bank Reference", value: 1 },
    { label: "Amount", value: 2 },
  ];

  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  //const [filterValue, setFilterValue] = useState("");
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isRestorePayment, setIsRestorePayment] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [masterData, setMasterData] = useState();
  const [apiData, setApiData] = useState();
  const [summary, setSummary] = useState();

  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const [viewDetail, setViewDetail] = useState(false);
  // const [startDate, setStartDate] = useState(
  //   moment().startOf("month").format("YYYY-MM-DD")
  // );
  // const [endDate, setEndDate] = useState(
  //   moment(new Date()).format("YYYY-MM-DD")
  // );

  const [startDate, setStartDate] = useState(() => {
    return (
      sessionStorage.getItem("landlordPayments_startDate") ||
      moment().startOf("month").format("YYYY-MM-DD")
    );
  });

  const [endDate, setEndDate] = useState(() => {
    return (
      sessionStorage.getItem("landlordPayments_endDate") ||
      moment().format("YYYY-MM-DD")
    );
  });

  const initialValues = {
    name: "",
    propertyName: "",
    //filterVal: filterValue,
    startDate: moment(new Date()).subtract(0, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const query = `&startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}&filter=${filter}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/landlord/payment/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.list);
      setMasterData(res?.list);
      setSummary(res?.summary);
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  // useEffect(() => {
  //   if (filterValue) {
  //     const handler = setTimeout(() => {
  //       getListMutate();
  //     }, 500);

  //     return () => {
  //       clearTimeout(handler);
  //     };
  //   }
  // }, [filterValue, startDate, endDate]);

  // useEffect(() => {
  //   if (filter) {
  //     const handler = setTimeout(() => {
  //       getListMutate();
  //     }, 100);

  //     return () => {
  //       clearTimeout(handler);
  //     };
  //   }
  // }, [filter]);

  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     // setIsFocused(false);
  //     getListMutate();
  //   }, 200);

  //   return () => {
  //     clearTimeout(handler);
  //   };
  // }, [property]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => clearTimeout(handler);
  }, [
    //property,
    startDate,
    endDate,
    //filterValue,
    filterType,
    searchQuery,
    filter,
  ]);

  // useEffect(() => {
  //   const savedStart = sessionStorage.getItem("landlordPayments_startDate");
  //   const savedEnd = sessionStorage.getItem("landlordPayments_endDate");

  //   if (savedStart && savedEnd) {
  //     setStartDate(savedStart);
  //     setEndDate(savedEnd);
  //   }
  // }, []);

  // Save dates whenever they update
  useEffect(() => {
    if (startDate) sessionStorage.setItem("landlordPayments_startDate", startDate);
    if (endDate) sessionStorage.setItem("landlordPayments_endDate", endDate);
  }, [startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const onSummaryBoxClick = (data) => {
    let filteredData;
    if (data === "CMS" || data === "TD")
      //Security
      filteredData = masterData.filter(
        (transaction) => transaction.type === 43
      );
    else if (data === "CMR")
      //Rent
      filteredData = masterData.filter(
        (transaction) => transaction.type === 1
      );
    else if (data === "App")
      //Online using Kipinn App
      filteredData = masterData.filter(
        (transaction) => transaction.recordedBy === "Kipinn App"
      );
    else filteredData = masterData;
    setApiData(filteredData);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Payments
            <Underline />
          </BoxTitle>
        </BoxHead>

        <SideModal
          isOpen={viewDetail}
          onClose={() => setViewDetail(false)}
        >
          <ViewTransDetails
            setViewDetail={setViewDetail}
            selectedData={selectedData}
            landlordName={selectedData?.landlordName || ""}
            landlordMobile={selectedData?.landlordMobile || ""}
          />
        </SideModal>

        {(isLoading || isRefetching) && !isFocused && (
          <LargeSummarySkeletonLoading count={4} />
        )}
        {isFocused && summary && (
          <>
            <SummaryCard summaryData={summary} user={user} onClick={onSummaryBoxClick} />
            <FilterTableWrapper>
              <FilterWrapper>

                <SearchFilterBox
                  options={searchOptions}
                  handleFilterChange={handleFilterChange}
                  handleClearFilters={handleClearFilters}
                />
                <div className="w-full md:w-auto md:ml-auto">
                  <DateRange
                    submitHandler={submitHandler}
                    defaultLabel={
                      moment(startDate).format("DD MMM yyyy") +
                      " - " +
                      moment(endDate).format("DD MMM yyyy")
                    }
                  />
                </div>
              </FilterWrapper>
              {!error && !isLoading && data && (
                <TableWrapper>
                  <Table
                    apiData={error ? [] : apiData}
                    setSelectedData={setSelectedData}
                    selectedData={selectedData}
                    setViewDetail={setViewDetail}
                    userType={user.userType}
                  />
                  {(error || apiData.length === 0) && !isLoading && (
                    <NotFoundModel />
                  )}
                </TableWrapper>
              )}
            </FilterTableWrapper>
          </>
        )}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
// const FilterWrapper = tw.div`flex w-full pb-4 lg:flex-row flex-col lg:gap-0 gap-4`;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm ml-auto`;
const DownloadBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-hover-color h-full py-1.5 text-sm`;

export default Payments;
